import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PropertyFeatureService } from '../property-feature.service';
import { PropertyFeature } from '../property-feature';
import { PropertyFeatureComponent } from '../property-feature/property-feature.component';
import { PropertyService } from '@app/_components/property';
import { FeatureService } from '@app/_components/property/feature';
import { PropertyFeatureTemplateDetailComponent } from '../../property-feature-template/property-feature-template-detail/property-feature-template-detail.component';

@Component({
    selector: 'app-property-feature-list',
    templateUrl: './property-feature-list.component.html',
    styleUrls: ['./property-feature-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PropertyFeatureListComponent implements OnInit {
	properties: any;
	features: any;
    kbmMapValues = [];
    vrboMapValues = [];
    titleValues = [];

	constructor(
		private featureService: FeatureService,
		private propertyService: PropertyService,
		private propertyFeatureService: PropertyFeatureService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = propertyFeatureService.statuses
	}



	// data
	propertyFeatures: any;
	propertyFeature: PropertyFeature;
	propertyFeaturesList: any[] = [];

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'featureVO.featureId', header: 'FeatureId', width: 'auto' },
		{ field: 'shortTermRentalVO.shortTermRentalId', header: 'StrId', width: 'auto' },
		{ field: 'shortTermRentalVO.propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'developmentVO.developmentId', header: 'DevelopmentId', width: 'auto' },
		{ field: 'title', header: 'Title', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'featureDesc', header: 'Description', width: 'auto' },
		{ field: 'featureVO.defaultHighlight', header: 'Highlight', width: 'auto' },
		{ field: 'featureVO.featureType', header: 'Feature Type', width: 'auto' },
		{ field: 'featureVO.defaultFeature', header: 'Default Feature', width: 'auto' },
		{ field: 'featureVO.featureLabel', header: 'Feature Label', width: 'auto' },
		{ field: 'quantity', header: 'Quantity', width: 'auto' },
		{ field: 'distance', header: 'Distance', width: 'auto' },
		{ field: 'distanceUnit', header: 'Distance Unit', width: 'auto' },
		{ field: 'featureVO.describesType', header: 'Describes Type', width: 'auto' },
		{ field: 'featureVO.kbmMap', header: 'kbmMap', width: 'auto' },
		{ field: 'featureVO.vrboMap', header: 'VrboMap', width: 'auto' },
		{ field: 'featureVO.rentalsUnitedMap', header: 'RentalsUnitedMap', width: 'auto' },
	];




	ngOnInit(): void {
		this.fetchTitleValues();
		this.fetchKbmMapValues();
		this.fetchVrboMapValues();
		this.fetchProperties();
		this.fetchFeature();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.propertyFeatureId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-propertyFeature-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyFeatureService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.propertyFeatures;
						this.recordTotal = res.page.recordTotal;
						this.propertyFeatures = res.data.propertyFeatures;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.propertyFeatures = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(propertyFeature: PropertyFeature) {
		try {
			this.formLoading = true;
			this.propertyFeatureService.update(propertyFeature)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.propertyFeatures.map((propertyFeature, i) => {
							if (propertyFeature.propertyFeatureId === res.data.propertyFeature.propertyFeatureId) {
								this.propertyFeatures[i] = res.data.propertyFeature;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(propertyFeature: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(propertyFeature));

			this.formLoading = true;
			this.propertyFeatureService.delete(propertyFeature.propertyFeatureId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.propertyFeatures.splice(this.propertyFeatures.indexOf(propertyFeature), 1);
						this.recordTotal = this.propertyFeatures.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PropertyFeature ' + propertyFeature.propertyFeatureId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PropertyFeature ' + propertyFeature.propertyFeatureId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Property Feature'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPropertyFeatureCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(propertyFeature: PropertyFeature) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyFeature: propertyFeature,
			title: 'Edit Property Feature'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePropertyFeatureCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePropertyFeatureCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPropertyFeatureCB(propertyFeature: PropertyFeature) {
		console.log('Adding PropertyFeature: ' + JSON.stringify(propertyFeature));
		// if we don't have a propertyFeatures array yet...
		if (!this.propertyFeatures) {
			this.propertyFeatures = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.propertyFeatures.unshift(propertyFeature);

		// no idea what this is but it is required to update the array
		this.propertyFeatures = [...this.propertyFeatures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyFeature ' + propertyFeature.propertyFeatureId + ' Added', life: 3000 });
	}

	updatePropertyFeatureCB(propertyFeature: PropertyFeature) {
		console.log('Updating PropertyFeature: ' + JSON.stringify(propertyFeature));
		let itemIndex = this.propertyFeatures.findIndex((item: any) => item.propertyFeatureId === propertyFeature.propertyFeatureId);
		this.propertyFeatures[itemIndex] = propertyFeature;

		// no idea what this is but it is required to update the array
		this.propertyFeatures = [...this.propertyFeatures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyFeature ' + propertyFeature.propertyFeatureId + ' Updated', life: 3000 });
	}

	deletePropertyFeatureCB(propertyFeature: PropertyFeature) {
		console.log('Removing PropertyFeature: ' + propertyFeature);
		this.propertyFeatures.splice(this.propertyFeatures.indexOf(propertyFeature), 1);
		this.recordTotal = this.propertyFeatures.length;

		// no idea what this is but it is required to update the array
		this.propertyFeatures = [...this.propertyFeatures];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyFeature ' + propertyFeature.propertyFeatureId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.propertyFeatures ? this.first === (this.propertyFeatures.length - this.rows) : true; }
	isFirstPage(): boolean { return this.propertyFeatures ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(propertyFeature: any) {
		if (propertyFeature?.status) {
			const status = this.statuses.find((e: any) => e.value == propertyFeature.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	fetchFeature() {
		if (!this.features || this.features === undefined || this.features.length < 1) {
			try {
				this.featureService.findAll()
					.subscribe(
						res => {
							console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.features = res.data.features;
							return this.features;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.features);
		}
	}
	
	fetchKbmMapValues() {
		if (!this.kbmMapValues || this.kbmMapValues === undefined || this.kbmMapValues.length < 1) {
			try {
				this.propertyFeatureService.findKbmMapValues()
					.subscribe(
						res => {
							console.log('findKbmMapValues: ' + JSON.stringify(res));
							for(var i = 0; i <= res.data.propertyFeatures.length ; i++){
								var kbmMapValueObj = {
									name: res.data.propertyFeatures[i],
									value: res.data.propertyFeatures[i]
								}
					             this.kbmMapValues.push(kbmMapValueObj);
					         }
							return this.kbmMapValues;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.kbmMapValues);
		}
	}
	
	fetchVrboMapValues() {
		if (!this.vrboMapValues || this.vrboMapValues === undefined || this.vrboMapValues.length < 1) {
			try {
				this.propertyFeatureService.findVrboMapValues()
					.subscribe(
						res => {
							console.log('findvrboMapValues: ' + JSON.stringify(res));
							for(var i = 0; i <= res.data.propertyFeatures.length ; i++){
								var kbmMapValueObj = {
									name: res.data.propertyFeatures[i],
									value: res.data.propertyFeatures[i]
								}
					             this.vrboMapValues.push(kbmMapValueObj);
					         }
							return this.vrboMapValues;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.vrboMapValues);
		}
	}
	
	fetchTitleValues() {
		if (!this.titleValues || this.titleValues === undefined || this.titleValues.length < 1) {
			try {
				this.propertyFeatureService.findTitleValues()
					.subscribe(
						res => {
							console.log('findTitleValues: ' + JSON.stringify(res));
							for(var i = 0; i <= res.data.propertyFeatures.length ; i++){
								var kbmMapValueObj = {
									name: res.data.propertyFeatures[i],
									value: res.data.propertyFeatures[i]
								}
					             this.titleValues.push(kbmMapValueObj);
					         }
							return this.titleValues;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.titleValues);
		}
	}
	
	addIntoCheckedList(propertyFeature: any){
		var count = 0;
		for (let i = 0; i < this.propertyFeaturesList.length; i++) {
		  if (this.propertyFeaturesList[i].propertyFeatureId == propertyFeature.propertyFeatureId) {
			this.propertyFeaturesList.splice(this.propertyFeaturesList.indexOf(this.propertyFeaturesList[i]), 1);
			count = 1;
			}
		}
		if (count == 0) {
			this.propertyFeaturesList.push(propertyFeature);
		}
		console.log("propertyFeaturesList : "+JSON.stringify(this.propertyFeaturesList));
	}
	
	/*********
		 * Add To PropertyFeatureTemplate
		 *
		 */
	addToPropertyFeatureTemplate() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'List of Property Feature Template',
			propertyFeatures: this.propertyFeaturesList
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyFeatureTemplateDetailComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}
}
